import { Component, OnInit, AfterContentInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from 'src/app/service/enrollmentAcceptedStudent.service';
import { FileService } from 'src/app/service/file.service';
import { CoursesService } from 'src/app/service/courses.service';


import { environment } from 'src/environments/environment';
import { Console } from 'console';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { AttendanceService } from 'src/app/service/attendance.service';
import { ScoresService } from 'src/app/service/scores.service';
import { ThisReceiver } from '@angular/compiler';
import { forkJoin, of } from 'rxjs';
import { catchError, ignoreElements, map } from 'rxjs/operators';

// Excel sheet export
import { Cell, Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { decimalDigest } from '@angular/compiler/src/i18n/digest';
import * as XLSX from 'xlsx';
import { threadId } from 'worker_threads';
import { borderTopRightRadius } from 'html2canvas/dist/types/css/property-descriptors/border-radius';
declare var $: any;
@Component({
  selector: 'app-course-assessment-units',
  templateUrl: './course-assessment-units.component.html',
  styleUrls: ['./course-assessment-units.component.scss']
})
export class CourseAssessmentUnitsComponent implements OnInit, AfterContentInit {


  select: any;
  showLoader: boolean = false;
  Searched: boolean = false;
  assessUnits: any = [];

  years: any;
  semesters: any;
  batches: any;
  orgId: any;
  username: any;


  currentYear: any;
  currentSemester: any;
  currentBatch: any;
  currentStatus: any;
  currentCourse: any;

  urlSearchYear: any;
  urlSearchSemester: any;
  urlSearchBatch: any;
  urlSearchStatus: any;
  urlSearchCourse: any;

  table: any;

  excelHeaderName: any;

  photoPath: any = `${environment.API_URL_UTIL}/api/downloadFile/`;

  courses: any = [];
  allCourses: any = [];
  dateStatus: any = [];
  searchForm = new FormGroup({
    year: new FormControl('', [
      Validators.required,
    ]),
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,
    ]),
    course: new FormControl('', [
      Validators.required,
    ]),
  });
  assUnits: any;

  constructor(private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, private router: Router, public translate: TranslateService, private fileService: FileService, private enrollmentGroupService: EnrollmentGroupService, private coursesService: CoursesService,
    private attendance: AttendanceService
    , private scoresService: ScoresService
    , private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.currentYear = this.urlSearchYear = params['yearId'] || "";
        this.currentSemester = this.urlSearchSemester = params['semesterId'] || "";
        this.currentBatch = this.urlSearchBatch = params['batchId'] || "";
        this.currentCourse = this.urlSearchCourse = params['subjectId'] || "";

        this.searchForm.controls.year.setValue(this.currentYear);
        this.searchForm.controls.semester.setValue(this.currentSemester);
        this.searchForm.controls.batch.setValue(this.currentBatch);
        this.searchForm.controls.course.setValue(this.currentCourse);

        this.getYears();
      });
    // Get attendace status (to select new status)
    // this.assessUnits = [{
    //   id: 1,
    //   course: "corse1",
    //   assUnit: "assunit",
    //   order: "10",
    //   score: "20",
    //   weight: "30",
    //   nameAr: "namear",
    //   nameaen: "nameen",
    //   active: "YES"

    // }, {
    //   id: 2,
    //   course: "corse2",
    //   assUnit: "assunit",
    //   order: "10",
    //   score: "20",
    //   weight: "30",
    //   nameAr: "namear",
    //   nameaen: "nameen",
    //   active: "YES"

    // },
    // {
    //   id: 3,
    //   course: "corse3",
    //   assUnit: "assunit",
    //   order: "10",
    //   score: "20",
    //   weight: "30",
    //   nameAr: "namear",
    //   nameaen: "nameen",
    //   active: "YES"

    // },
    // {
    //   id: 4,
    //   course: "corse4",
    //   assUnit: "assunit",
    //   order: "10",
    //   score: "20",
    //   weight: "30",
    //   nameAr: "namear",
    //   nameaen: "nameen",
    //   active: "YES"

    // }
    // ]


    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
      //this.initFormDropDownsFields();
    });
  }

  ngAfterContentInit(): void {


  }



  searchFormChange() {
  }

  searchFormSubmit() {
    if (this.searchForm.valid) {
      this.Searched = true;
      this.currentYear = this.searchForm.controls.year.value;
      this.currentSemester = this.searchForm.controls.semester.value;
      this.currentBatch = this.searchForm.controls.batch.value;
      this.currentCourse = this.searchForm.controls.course.value;

      this.getAssUnitsAndCourseAndAssUnits();
    } else {
      this.Searched = false;
      this.searchForm.markAllAsTouched();
      this.searchForm.markAsDirty();
    }
  }

  // searchForCourseAssUnits() {
  //   this.showLoader = true;
  //   this.scoresService.searchForCourseAssUnit(this.orgId, this.currentYear, this.currentSemester, this.currentBatch, this.currentCourse)
  //     .subscribe(
  //       data => {
  //         this.assessUnits = data;
  //         this.updateTable();
  //         this.showLoader = false;
  //       },
  //       error => {
  //         this.assessUnits = [];
  //         this.showLoader = false;
  //         this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
  //       }
  //     );
  // }

  // test() {
  //   console.log(this.table.rows({ selected: true }).data().toArray());
  //   // let currentDatatableRows = this.table.rows({ select: 'current' }).data().toArray();
  //   //.rows({ select: 'current' }).data().toArray()
  // }

  getYears() {
    this.showLoader = true;
    this.enrollmentGroupService.getYears()
      .subscribe(
        data => {
          this.years = data;
          if (this.urlSearchYear != '') {

            this.getYearSemesters();
          } else {
            this.showLoader = false;
          }
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getYearSemesters() {
    let year = this.searchForm.controls.year.value;
    if (year) {
      this.enrollmentGroupService.getYearSemesters(year)
        .subscribe(
          data => {
            this.semesters = data;
            if (this.urlSearchSemester != '') {
              this.getBatches();
            }
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.semester.reset();
      this.semesters = [];
    }
  }

  getBatches() {
    let year = this.searchForm.controls.year.value;
    let semester = this.searchForm.controls.semester.value;
    if (year && semester) {
      this.enrollmentGroupService.getSemesterBatches(this.orgId, year, semester)
        .subscribe(
          data => {
            this.batches = data;
            if (this.urlSearchBatch != '') {
              this.getBatchCourses();
            }
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.batch.reset();
      this.batches = [];
    }
  }

  getBatchCourses() {
    let batch = this.searchForm.controls.batch.value;
    if (batch) {
      this.enrollmentGroupService.getBatchSubjects(this.orgId, batch)
        .subscribe(
          data => {
            this.courses = data;
            if (this.urlSearchYear != "" && this.urlSearchSemester != "" && this.urlSearchBatch != "" && this.urlSearchCourse != "") {
              this.Searched = true;
              this.getAssUnitsAndCourseAndAssUnits();
            }
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.course.reset();
      this.courses = [];
    }
  }

  updateTable() {
    if (this.table) {
      $("#datatable").DataTable().destroy();
    }

    setTimeout(() => {
      this.table = $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        rowReorder: true,
        "columnDefs": [
          { orderable: true, className: 'reorder', targets: [0] },
          { orderable: false, targets: '_all' }
        ],
        // pageLength: 5,
        paging: false,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'excelHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'EXCEL',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
          },
          className: 'datatable_custom_buttons',
        }],
      });

      let dataTableButtonsDiv = <HTMLElement>document.getElementsByClassName('dt-buttons')[0];
      if (dataTableButtonsDiv != null) {
        dataTableButtonsDiv.style.padding = '0px 15px 0px 15px';
      }
      // Test datatable function start
      // console.log(table.rows({ search: 'applied', order: 'applied' }).data());
      // table.on('row-reordered', function (e: any, details: any, edit: any) {
      // console.log(table.rows({order:'current'}).data());
      // console.log('row-reordered');
      // console.log(table.rows().data());
      // var indexes = table.rows().indexes().toArray();
      // for (var r = 0; r < indexes.length; r++) {
      //   //get row data
      //   var data = table.row(indexes[r]).data();
      //   console.log(data);
      // }
      // });
      // Test datatable function end

    }, 1);

  }

  copyFromPreviosSemester() {
    this.showLoader = true;
    this.scoresService.copyPreviousSemesterAssessments(this.orgId, this.currentYear, this.currentSemester, this.username)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
          }
          this.getAssUnitsAndCourseAndAssUnits();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GENERATE_REPORT_AT_DATA_BE'));
          this.showLoader = false;
        }
      );

  }

  applyOrder() {
    // console.log(this.assessUnits);
    this.rearrangeAssessListAccordingToTable();
    // console.log(this.assessUnits);
  }

  rearrangeAssessListAccordingToTable() {
    let currentDatatableRows = this.table.rows({ order: 'current' }).data().toArray();
    // console.log(currentDatatableRows);
    let newUnitListOrder: any = [];
    let oldUnitListOrder = this.assessUnits;
    currentDatatableRows.forEach((element: any) => {
      let found = false;
      oldUnitListOrder = oldUnitListOrder.filter((unit: any) => {
        // if (!found && element[0] == unit.id) {
        if (element[1] == unit.id) {
          console.log(unit.id);
          unit.orderNo = element[0];
          newUnitListOrder.push(unit);
          // found = true;
          return false;
        } else {
          return true;
        }
      });
    });

    this.assessUnits = newUnitListOrder;
    // console.log(">>> ");
    // console.log(this.assessUnits);
    // Apply update for backend
    this.applyUnitsUpdate();
  }

  getAssUnitsAndCourseAndAssUnits() {
    // Reset URL search params
    this.urlSearchYear = '';
    this.urlSearchSemester = '';
    this.urlSearchBatch = '';
    this.urlSearchCourse = '';

    this.showLoader = true;
    let bulkApis = [
      this.scoresService.getAllAssesmentUnit(),
      this.coursesService.getAllCourses(),
      this.scoresService.searchForCourseAssUnit(this.orgId, this.currentYear, this.currentSemester, this.currentBatch, this.currentCourse),
    ];

    forkJoin(bulkApis).subscribe(
      data => {
        // console.log(data);
        if (typeof data[0] != undefined)
          this.assUnits = data[0];

        if (typeof data[1] != undefined)
          this.allCourses = data[1];

        if (typeof data[2] != undefined && data[2].length > 0) {
          this.assessUnits = data[2];
          let counter = 0;
          this.assessUnits = this.assessUnits.map((element: any) => {
            counter += 1;
            let assUnitId = element.asesid;
            let subjectid = element.subjectid;
            let assUnit = this.assUnits.filter((i: any) => i.id == assUnitId)[0];
            let course = this.allCourses.filter((i: any) => i.id == subjectid)[0];
            let no = counter;
            return { ...element, assUnit, course, no };
          });
          this.updateTable();
        } else {
          this.assessUnits = [];
          this.toastrService.warning(this.translate.instant("NO_DATA_FOUND"));
        }

        this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
        this.showLoader = false;
      }
    );
  }

  applyUnitsUpdate() {
    this.showLoader = true;
    // let bulkApis = [];
    let bulkApis = this.assessUnits.map((unit: any) => {
      return this.scoresService.updateCourseAssUnit(this.username, unit.id, this.orgId, unit).pipe(map(res => res), catchError(e => of('Oops!')));
    });

    forkJoin(bulkApis).subscribe(
      data => {
        let unitsupdateFail = 0;
        let unitsupdateSuccess = 0;
        data.forEach((msg: any) => {
          if (msg.sts == 'SUCCESS') {
            unitsupdateSuccess++;
          } else {
            unitsupdateFail++;
          }
        });

        this.toastrService.info(this.translate.instant("SUCCESS") + " (" + unitsupdateSuccess + ") " + this.translate.instant("FAIL") + " (" + unitsupdateFail + ").");
        this.getAssUnitsAndCourseAndAssUnits();

      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_UPDATE"));
      },
      () => {
        this.showLoader = false;
        this.updateTable();
      }
    );
  }


}

